<template>
  <div class="orderList">
    <div class="head">
      <div style="flex:9;padding-left:20px;">
        <span style="flex:3;">商品名称</span>
        <span style="flex:2;">商品属性</span>
        <span style="flex:1.5;">单价</span>
        <span style="flex:2.5;">数量</span>
      </div>
      <div style="flex:9;padding-right:20px;">
        <span style="flex:3;">服务时间</span>
        <span style="flex:1.5;">实付款</span>
        <span style="flex:1.5;">状态</span>
        <span style="flex:3;text-align:left;">操作</span>
      </div>
    </div>
    <div v-if="flag">
      <div class="content" v-for="(item, index) in orderList" :key="index">
        <div class="top">
          <div class="left">
            <span class="shopName" @click="toStore(item.shopId)">
              <img v-if="item.shopLogo" :src="item.shopLogo" alt />
              <img v-else src="../../assets/images/logo.png" alt />
              {{ item.shopName }}
            </span>
            <span class="time">{{ item.createTime }}</span>
            <span class="orderCode">订单号：{{ item.orderFormid }}</span>
            <!-- <span>支付方式：{{item.paymentMode | paymentModeFormat}}</span> -->
          </div>
          <div class="right">
            <img class="cur-poi" v-if="item.state == 5" src="../../../static/image/shanchu@2x.png" alt
              @click="$emit('isDelete', item.orderId)" />
          </div>
        </div>
        <div class="productBox">
          <div class="product">
            <div class="left fs13" style="flex:16;">
              <div class="box" v-for="(items, indexs) in item.skus" :key="indexs">
                <div class="desc cur-poi" @click="toProductDetail(item.shopId, items)">
                  <img :src="items.image" alt />
                  <div>
                    <p class="name">{{ items.productName }}</p>
                  </div>
                </div>
                <div class="price">
                  <span v-for="(val, idx) in items.values" :key="idx">{{ val }}</span>
                </div>
                <div class="price">
                  <span>¥{{ items.price }}</span>
                  <del style="color:#999;" v-if="items.originalPrice && items.originalPrice != items.price">¥{{
                      items.originalPrice
                  }}</del>
                </div>
                <div class="num">
                  <p class="fs14">x {{ items.checkNumber }}</p>
                </div>
                <div class="name" v-if="items.timeSkuStatus"
                  style="width: 24%;text-align: center;display: flex;flex-direction: column;justify-content: center;">
                  <div>起始日期:{{ items.timeSkuStart }}</div>
                  <div>结束日期:{{ items.timeSkuEnd }}</div>
                  <div>总计:{{ items.timeSkuNumber }}{{ items.timeSkuName }}</div>
                </div>
              </div>
            </div>
            <div class="right" :class="item.skus.length > 1 ? 'right_line' : ''">
              <div class="consignee">{{ item.receiveName }}</div>
              <div class="actualPay">
                <div v-if="!isSchool">
                  <p class="fs13 mar-bot-5">¥{{ (item.orderPrice - item.discountPrice).toFixed(2) }}</p>
                  <p v-if="item.originalPrice != 0" class="fs13 mar-bot-5"
                    style="text-decoration:line-through;color:#999">¥{{ (item.originalPrice -
                        item.discountPrice).toFixed(2)
                    }}</p>
                  <!-- <p class="fs13">(含运费：¥{{item.logisticsPrice}})</p> -->
                </div>
                <div v-else>
                  <p class="fs13 mar-bot-5">¥{{ (item.checkPrice - item.discountPrice).toFixed(2) }}</p>
                  <!-- <p class="fs13 mar-bot-5" style="color:#999;">首次支付金额: ¥{{(item.orderPrice -
                  item.discountPrice).toFixed(2)}}</p> -->
                  <p class="fs13 mar-bot-5" v-if="item.checkPrice - item.orderPrice > 0 && item.state == 4">已追加支付金额:
                    <span style="color:#ff4747">¥{{ (item.checkPrice - item.orderPrice).toFixed(2) }}</span>
                  </p>
                  <p class="fs13 mar-bot-5" v-if="item.checkPrice - item.orderPrice < 0 && item.state == 4">已退款金额: <span
                      style="color:#ff4747">¥{{ (item.orderPrice - item.checkPrice).toFixed(2) }}</span></p>
                  <p v-if="item.originalPrice != 0" class="fs13 mar-bot-5"
                    style="text-decoration:line-through;color:#999">¥{{ (item.originalPrice -
                        item.discountPrice).toFixed(2)
                    }}</p>
                  <!-- <p class="fs13">(含运费：¥{{item.logisticsPrice}})</p> -->
                </div>
              </div>
              <div class="status">
                <div>
                  <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state == 1">待卖家确认</p>
                  <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state == 2">待付款</p>
                  <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state == 3">待核销</p>
                  <p class="fs13 mar-bot-5 font-color-71B" v-if="item.state == 4">已完成</p>
                  <p class="fs13 mar-bot-5 font-color-999" v-if="item.state == 5">已关闭</p>
                  <!-- <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.state==6">待成团</p> -->
                  <!-- <p class="fs13 cur-poi" @click="toOrderDetail(item.orderId,item)">订单详情</p> -->
                </div>
              </div>
              <div class="operate">
                <div>
                  <!-- <el-button type="primary" class="fs13 mar-bot-5" size="small" :disabled="item.orderFrom == 1"
                    v-if="item.state==1 || item.paymentState==0 && item.state==6" @click="getUrl(item)" v-throttle>
                    {{item.orderFrom == 1 ? "待卖家收款": "去付款"}}</el-button> -->
                  <!-- <el-button type="primary" class="fs13 mar-bot-5" size="small"
                    v-if="item.state==2 && item.orderFrom != 1" @click="remind(item.orderId)" v-throttle>提醒发货
                  </el-button> -->
                  <!-- <el-button type="primary" class="fs13 mar-bot-5" size="small" :disabled="item.orderFrom == 1"
                    v-if="item.state==2 && item.orderFrom != 1" @click="getUrl(item)" v-throttle>
                    {{item.orderFrom == 1 ? "待卖家收款": "去付款"}}</el-button> -->
                  <!-- <el-button type="primary" class="fs13 mar-bot-5" size="small"
                    v-if="item.state == 3 && item.ifAfter == 1 && item.orderFrom != 1"
                    @click="$emit('isConfirm', item.orderId, item)" v-throttle>确认收货</el-button> -->
                  <el-button type="primary" class="fs13 mar-bot-5" size="small"
                    v-if="(item.state == 4 || item.state == 5) && item.orderFrom != 1" @click="buyAgain(item.orderId)"
                    v-throttle
                    :disabled="item.shopDiscountId != 0 || item.shopGroupWorkId != 0 || item.shopSeckillId != 0">
                    再次购买</el-button>
                  <!-- <el-button class="fs13 cur-poi" size="small" @click="$emit('isCancel',item.orderId)"
                    v-if="(item.state==1 || item.state==6) && item.orderFrom != 1" v-throttle>取消订单</el-button> -->
                  <!-- <el-button class="fs13  cur-poi" size="small" @click="toAfterSale(item)" v-if="item.state==2" v-throttle>退货/退款</el-button> -->
                  <!-- <el-button class="fs13  cur-poi" size="small" @click="$emit('isRefund',item)" v-if="item.state==3 && item.ifAfter || item.state==4 && item.ifAfter" v-throttle>退货/退款</el-button> -->
                  <!-- <el-button class="fs13 cur-poi" size="small"
                    v-if="item.state==4 && item.ifNotComment ===1 && item.orderFrom != 1" @click="toEvaluate(item)"
                    v-throttle>评价</el-button>
                  <el-button class="fs13 cur-poi" size="small" v-if="item.state==3 && item.orderFrom != 1"
                    @click="toOrderDetail(item.orderId)" v-throttle>查看物流</el-button> -->
                  <el-button class="fs13 mar-bot-5 detail" size="small" @click="toOrderDetail(item.orderId, item)"
                    v-throttle>订单详情</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="banxin" v-if="item.billList.length > 0" style="padding:0 20px;">
          <div style="font-size: 18px;font-weight: bold;padding: 15px 0px;display:flex;align-items:center;"><i
              style="display:inline-block;width: 3px;height: 18px;background: #F77B0B;margin-right:10px;"></i>账单信息</div>
          <div style="display:flex;align-items:baseline;margin-bottom:15px;">
            <span style="font-size: 16px;font-weight: bold;margin-right:5px;">订单总金额:</span>
            <span style="font-size: 22px;font-weight: bold;margin-right:20px;">¥{{ (item.orderPrice).toFixed(2)
            }}</span>
            <span style="font-size: 16px;font-weight: bold;margin-right:5px;">已出账金额:</span>
            <span style="font-size: 22px;font-weight: bold;">¥{{ item.billList.map(el => el.billAmount).reduce((total,
                cur) => (total + cur)).toFixed(2)
            }}</span>
          </div>
          <div>
            <div style="display: flex;background: #cccccc4f;padding: 10px;">
              <span style="width:5%;text-align:center;">
                <el-checkbox v-model="item.allchecked" @change="allClick($event, item)"></el-checkbox>
              </span>
              <span style="width:15%;text-align:center;">账单号</span>
              <span style="width:10%;text-align:center;">账单金额(元)</span>
              <span style="width:10%;text-align:center;">账单状态</span>
              <span style="width:10%;text-align:center;">截止时间</span>
              <span style="width:10%;text-align:center;">备注</span>
              <span style="width:15%;text-align:center;">订单号</span>
              <span style="width:15%;text-align:center;">创建时间</span>
              <span style="width:10%;text-align:center;margin-left:auto;">更新时间</span>
            </div>
            <div v-for="(item2, index) in item.billList" :key="index"
              style="display:flex;align-items:center;padding:20px 10px;border: 1px solid #E5E5E5FF;border-top: none;">
              <span style="width:5%;text-align:center;">
                <el-checkbox v-model="item2.checked" @change="itemClick($event, item, item2)"
                  :disabled="item2.billStatus == 1 ? true : false"></el-checkbox>
              </span>
              <span style="width:15%;text-align:center;">
                {{ item2.billFormid }}
              </span>
              <span style="width:10%;text-align:center;">
                {{ item2.billAmount }}
              </span>
              <span style="width:10%;text-align:center;">
                <span v-if="item2.billStatus == 0" style="color:#F77B0BFF;">待支付</span>
                <span v-if="item2.billStatus == 1" style="color:#00AA5BFF;">已支付</span>
                <span v-if="item2.billStatus == 2" style="color:#FF4747FF;">已逾期</span>
              </span>
              <span style="width:10%;text-align:center;">
                {{ item2.billEx }}
              </span>
              <span style="width:10%;text-align:center;">
                {{ item2.remark }}
              </span>
              <span style="width:15%;text-align:center;">
                {{ item2.orderFormid }}
              </span>
              <span style="width:15%;text-align:center;">
                {{ item2.createTime }}
              </span>
              <span style="width:10%;text-align:center;margin-left:auto;">
                {{ item2.updateTime }}
              </span>
            </div>
          </div>
          <div v-if="item.payCount != item.billList.length"
            style="display:flex;justify-content:flex-end;align-items:center;margin:10px 0;">
            <el-button :loading="item.payLoad" type="primary" @click="confirmPay(item)">立即支付</el-button>
          </div>

        </div>
      </div>
      <el-pagination :current-page="page" :page-size="5" @current-change="handleCurrentChange" background
        layout="prev, pager, next" :total="total"></el-pagination>
    </div>
    <div class="noorder" v-else>
      <img src="../../../static/image/noorder@2x.png" alt />
      <p class="fs20 font-color-999">您还没有订单哦～</p>
      <router-link to="/">
        <el-button>去首页看看</el-button>
      </router-link>
    </div>
    <el-dialog class="weChat" :visible.sync="weChatDialog" :before-close="handleClose" width="25%">
      <div class="weChatBox" style="">
        <div style="font-size:18px;color:#000000;padding:0 20px;">
          请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）
        </div>
        <div style="font-size:32px;color:#000000;width:100%;text-align:center;">￥{{ payInfo.money }}</div>
        <div class="qCode">
          <img :src="`data:image/jpeg;base64,${payInfo.c2bQrCodeBase64}`" width="100%" height="100%" alt />
          <!-- <img src="../../assets/images/weiXintit.png" alt=""> -->
        </div>
        <!-- <div class="weChatInfo">
            <img src="../../assets/images/imgPay.png" alt="">
        </div>-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../api";
import api_b2c from "../../api_b2c";
import api_serv from "../../api_serv";
import { listSearchMixin } from "../../config/mixin";
export default {
  props: ["orderList", "total", "page", "flag"],
  mixins: [listSearchMixin],
  data() {
    return {
      isSchool: localStorage.getItem('isSchool') == 'true',
      payInfo: {},
      weChatDialog: false,
      chatTimer: "",
      submitData: {
        receiveId: "",
        couponId: "",
        price: "",
        remark: "",
        shops: [],
      },
      // payLoad: false,
      platform:'b2b'
    };
  },
  mounted() {
    this.platform = localStorage.getItem('platform');
    for (let i = 0; i < this.orderList.length; i++) {
      this.orderList[i].allchecked = false
      this.orderList[i].payLoad = false
      this.orderList[i].payCount = 0
      for (let j = 0; j < this.orderList[i].billList.length; j++) {
        this.orderList[i].billList[j].checked = false
        if (this.orderList[i].billList[j].billStatus == 1) {
          this.orderList[i].payCount++
        }
      }
    }
    this.$forceUpdate();
    console.log(this.orderList);
  },
  computed: {
    ...mapGetters([
      "userInfo", // 用户信息
    ]),
  },
  watch: {
    orderList: { // 深度监听
      handler(val, oldVal) {
        this.orderList = val
        console.log('currentForm', val, oldVal)
        // 但是这两个值打印出来却都是一样的,因为它们的引用指向同一个对象/数组
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setCartNumber: "SET_CARTNUMBER",
      setShoppingCart: "SET_SHOPPINGCART"
    }),
    allClick(e, item) {
      console.log(e)
      for (let j = 0; j < item.billList.length; j++) {

        if (e) {
          item.billList[j].checked = true
        } else {
          item.billList[j].checked = false
        }
      }
      this.$forceUpdate();
      console.log(this.orderList)
    },
    itemClick(e, item, item2) {

      console.log(e)

      let count = 0
      for (let j = 0; j < item.billList.length; j++) {
        if (item.billList[j].checked == true) {
          count++
        }
      }
      if (count == item.billList.length) {
        item.allchecked = true
      }
      for (let k = 0; k < this.orderList.length; k++) {
        if (item.orderId == this.orderList[k].orderId) {
          this.orderList[k] = item
        }
        for (let l = 0; l < this.orderList[k].billList.length; l++) {
          if (item2.billId == this.orderList[k].billList[l].billId) {
            this.orderList[k].billList[l] = item2
            if (e) {
              this.orderList[k].billList[l].checked = true
            } else {
              this.orderList[k].billList[l].checked = false
              this.orderList[k].allchecked = false
            }
          }
        }
      }
      this.$forceUpdate();
      console.log(this.orderList)
    },
    //删除订单
    deleteOrder() {
      this.$parent.getOrderList();
    },
    //立即支付
    confirmPay(item) {
      
      this.$forceUpdate();
      //billPay
      // for (let j = 0; j < this.orderList.length; j++) {
      //   if (item.orderId == this.orderList[j].orderId) {
      //     this.orderList[j] = item
      //     this.orderList[j].payLoad = true
      //   }
      // }
      console.log(item)
      // this.$router.push({
      //   path: "../confirmPay_serv",
      //   query: {
      //     billInfo: item,
      //   },
      // });
      console.log(this.userInfo)
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {

        if (res.code === "200") {
          // self.setUserInfo(res.data);
          console.log(this.userInfo)
          let billIds = []
          for (let j = 0; j < item.billList.length; j++) {
            if (item.billList[j].checked == true) {
              item.billList[j].checked = true
              billIds.push(item.billList[j].billId)
            }
          }
          console.log(billIds.join(","))
          if (billIds.length == 0) {
            self.$message({
              message: "请选择要支付的账单",
              type: "warning",
            });
            return
          }
          item.payLoad = true
          let params2 = {
            url: api_serv.billPay,
            method: "post",
            data: {
              billIds: billIds.join(","),
              ip: '',
              orderId: item.orderId,
              user: res.data
            },
          };
          self.sendReq(params2, (res2) => {

            if (res2.code === "200") {
              console.log(res2)
              if (res2.data && res2.data.payUrl) {
                for (let j = 0; j < this.orderList.length; j++) {
                  if (item.orderId == this.orderList[j].orderId) {
                    item.payLoad = false
                    this.orderList[j].payLoad = false
                  }
                }
                this.$forceUpdate();
                // item.payLoad = false
                self.$message({
                  message: '即将跳转工行支付界面...',
                  type: "success",
                });
                setTimeout(() => {
                  // var a = document.createElement('a');
                  // a.setAttribute('href', res2.data.payUrl.url);
                  // a.setAttribute('target', '_blank');
                  // a.setAttribute('id', "toPay");
                  // // 防止反复添加
                  // if (!document.getElementById("toPay")) document.body.appendChild(a);
                  // a.click();
                  // let url = "https://cpay3.dccnet.com.cn/corporpay/servlet/ICBCCPayBusinessServlet?unique_serialno=2022110211261470900000000002820013&signstr=88DCA78EF441521B4E49DEC55DF1E03C74A14D2EE84EFE210CAFA25F913E8B13D5CEBBF7FCE625D2"
                  window.open(res2.data.payUrl.url)
                  // window.location.href = res.data.url

                }, 2000);
              }
            } else {
              for (let j = 0; j < this.orderList.length; j++) {
                if (item.orderId == this.orderList[j].orderId) {
                  item.payLoad = false
                  this.orderList[j].payLoad = false
                }
              }
              this.$forceUpdate();
              self.$message({
                message: res2.errorData || res2.message,
                type: "warning",
              });
            }
          });
        } else {
          for (let j = 0; j < this.orderList.length; j++) {
            if (item.orderId == this.orderList[j].orderId) {
              item.payLoad = false
              this.orderList[j].payLoad = false
            }
          }
          this.$forceUpdate();
          // item.payLoad = false
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 跳转到商品详情
    toProductDetail(id, item) {
      let data = {
        shopId: id,
        productId: item.productId,
        skuId: item.skuId
      };
      this.$router.push({
        path: "/productDetail_serv",
        query: {
          proData: JSON.stringify(data)
        }
      });
    },
    // 分页器跳转
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    // 提醒发货
    remind(id) {
      this.$message({
        message: "已提醒卖家发货",
        type: "success"
      });
    },
    // 跳转到店铺
    toStore(id) {
      this.$router.push({
        path: "/store",
        query: {
          shopId: id
        }
      });
    },
    // 跳转到订单详情
    toOrderDetail(id, item) {
      let paymentMode = null;
      if (item) {
        paymentMode = item.paymentMode;
      }
      this.$router.push({
        path: "/orderDetail_B2B_serv",
        query: {
          orderId: id
        }
      });
    },
    // 再次购买
    buyAgain(id) {
      let self = this;
      let params = { 
        url: this.platform == 'b2b' ? api.buyAgain : api_b2c.buyAgain,
        method: "PUT",
        data: {
          orderId: id
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          // self.$router.push("/shopping-trolley");
          if(this.platform == 'b2c'){
            self.$router.push("/shop_mall/shopping-trolley");
          }else{
            self.$router.push("/shopping-trolley");
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 跳转到评价
    toEvaluate(data) {
      this.$router.push({
        path: "/evaluate",
        query: {
          product: JSON.stringify(data)
        }
      });
    },
    // 申请售后
    toAfterSale(item) {
      this.$router.push({
        path: "/afterSale",
        query: {
          orderData: JSON.stringify(item),
          state: 1
        }
      });
    },
    // 去支付
    checkPay(paramsData) {
      setTimeout(() => {
        let self = this;
        let params = {
          url:
            api.checkPay +
            `?collageId=${paramsData.collageId}&money=${paramsData.money
            }&orderId=${paramsData.orderId}&type=2`,
          method: "GET"
        };
        self.sendReq(params, res => {
          if (res.code === "200") {
            if (res.data.code === "SUCCESS") {
              self.$message({
                message: "支付成功！",
                type: "success"
              });
              clearInterval(self.chatTimer);
              self.getTrolleyList();
              self.weChatDialog = false;
              self.toOrderDetail(paramsData.orderId);
            }
          } else {
            clearInterval(self.chatTimer);
            self.$message({
              message: res.message,
              type: "error"
            });
            self.weChatDialog = false;
          }
        });
      }, 0);
    },
    // 采购单列表
    async getTrolleyList() {
      const vm = this;
      const params = {
        url: api.getTrolleyList,
        method: "GET"
      };
      vm.sendReq(params, res => {
        const d = res.data;
        let cartNumber = 0;
        // console.log(d)
        if (d.length) {
          d.forEach(j => {
            cartNumber = cartNumber + j.skus.length;
          });
        }
        this.setShoppingCart(d);
        this.setCartNumber(cartNumber);
      });
    },
    // 去支付
    getUrl({ orderId, paymentMode, checkPrice }) {
      let self = this;
      if (paymentMode == 1 || paymentMode == 2) {
        let params = {
          url: api.getPayCode,
          method: "GET",
          payload: {
            orderId
          }
        };
        self.sendReq(params, res => {
          if (res.code === "200") {
            self.payInfo = res.data;
            self.weChatDialog = true;
            self.chatTimer = setInterval(() => {
              self.checkPay(res.data);
            }, 2000);
          } else {
            self.$message({
              message: res.message,
              type: "error"
            });
          }
        });
      } else if (paymentMode == 3) {
        this.$router.push({
          path: "/orderDetail_B2B",
          query: {
            orderId,
            showProcess: true
          }
        });
      } else if (paymentMode == 6) {
        this.$router.push({
          path: "/orderDetail",
          query: {
            orderId: orderId
          }
        });
        // let self = this;
        // let params = {
        //   url: api.orderSubmit,
        //   method: "POST",
        //   data: subData,
        // };

        // self.sendReq(params, (res) => {
        //   if (res.code === "200") {
        //     if (res.data && res.data.url) {
        //         self.$message({
        //           message: '订单提交成功，即将跳转支付...',
        //           type: "success",
        //         });
        //         setTimeout(() => {
        //           var a = document.createElement('a');
        //           a.setAttribute('href', res.data.url);
        //           a.setAttribute('target', '_blank');
        //           a.setAttribute('toPay', id);
        //           // 防止反复添加
        //           if (!document.getElementById(id)) document.body.appendChild(a);
        //           a.click();
        //           // window.location.href = res.data.url
        //           // window.open(res.data.url)
        //         }, 2000);
        //       }

        //   } else if (res.code === "70007") {
        //     self.$message({
        //       message:
        //         "订单金额超额（≥5万元），暂不支持在线支付，您可选择转账汇款或账期支付进行支付。",
        //       type: "warning",
        //     });
        //   } else {
        //     self.$message({
        //       message: res.message,
        //       type: "warning",
        //     });
        //   }
        // });
      } else if (paymentMode == 4) {
        let dialogPrice = checkPrice
        this.$confirm({
          title: "是否确认付款",
          content: (h) => <div>待付款金额: <span style="color:#ff4747;font-size:16px;">¥{dialogPrice}</span></div>,
          onOk() {
            let params = {
              url: api.getPayCode,
              method: "GET",
              payload: {
                orderId
              }
            };
            self.sendReq(params, res => {
              if (res.code === "200") {
                self.$message.success("支付成功!");
                self.$emit('getOrderList')
              } else {
                self.$message({
                  message: res.message,
                  type: "error"
                });
              }
            });
          },
          onCancel() { },
          class: "test"
        });
      }
    },
    handleClose() {
      let _this = this;
      this.$confirm({
        okText: "确定",
        cancelText: "取消",
        title: "取消支付",
        content: "确认取消支付？",
        onOk() {
          clearInterval(_this.chatTimer);
          _this.weChatDialog = false;
        },
        onCancel() { }
      });
      // this.$confirm('确认取消支付？')
      //   .then(_ => {
      //     clearInterval(this.chatTimer)
      //     this.weChatDialog = false
      //   })
      //   .catch(_ => {})
    }
  }
};
</script>
<style lang="scss" scoped>
.orderList {
  width: 100%;

  .noorder {
    width: 100%;
    text-align: center;
    padding: 100px 0;

    p {
      margin-bottom: 20px;
    }

    .el-button {
      background-color: #ff7800;
      color: #ffffff;
      font-weight: normal;
      border-radius: 0;
    }
  }

  .head {
    box-sizing: border-box;
    width: 100%;
    height: 44px;
    background-color: #f1f2f7;
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;

    div {
      display: flex;
    }
  }

  .content {
    width: 100%;
    margin-bottom: 20px;
    border: 1px solid #e5e5e5;
    border-bottom: 0;
    box-sizing: border-box;

    .top {
      width: 100%;
      font-size: 13px;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f3f3f3;

      .left {
        flex: 13;

        .shopName {
          margin-left: 20px;
          margin-right: 60px;
          cursor: pointer;

          img {
            width: 16px;
            // height: 16px;
            vertical-align: middle;
            margin-right: 5px;
          }
        }

        .time,
        .orderCode {
          margin-right: 60px;
        }
      }

      .right {
        flex: 4;
        display: flex;
        align-items: center;
        justify-content: left;
        padding-left: 10px;
      }
    }

    .productBox {
      width: 100%;
      box-sizing: border-box;

      .product {
        width: 100%;
        display: flex;

        .left {
          flex: 9;

          .box {
            padding: 20px 0 20px 20px;
            display: flex;
            border-bottom: 1px solid #e5e5e5;

            .desc {
              flex: 3;
              display: flex;

              img {
                width: 86px;
                height: 86px;
                margin-right: 10px;
              }

              div {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .name {
                  font-size: 14px;
                  margin: auto 0;
                }

                .size {
                  font-size: 13px;

                  span {
                    margin-right: 10px;
                  }

                  span:last-child {
                    margin-right: 0;
                  }
                }
              }
            }

            .price,
            .num {
              flex: 2;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }
          }
        }

        .right {
          padding: 0px 20px 0px 0;
          flex: 9;
          display: flex;
          border-bottom: 1px solid #e5e5e5;

          .actualPay {
            flex: 2;
            display: flex;
            justify-content: center;
            align-items: center;

            div {
              text-align: center;

              .el-button {
                border: 1px solid #ff7800;
                color: #ff7800;
                border-radius: 0;
              }
            }
          }

          .consignee {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;

            div {
              text-align: center;

              .el-button {
                border: 1px solid #ff7800;
                color: #ff7800;
                border-radius: 0;
              }
            }
          }

          .status {
            flex: 2;
            display: flex;
            justify-content: center;
            align-items: center;

            div {
              text-align: center;

              .el-button {
                border: 1px solid #ff7800;
                color: #ff7800;
                border-radius: 0;
              }
            }
          }

          .operate {
            flex: 4;
            display: flex;
            justify-content: left;
            align-items: center;

            div {
              text-align: center;

              .el-button {
                border: 1px solid #ff7800;
                color: #ff7800;
                border-radius: 0;
              }
            }

            div {
              text-align: center;

              .detail.el-button {
                border: 1px solid #e5e5e4;
                color: #999999;
                border-radius: 0;
              }
            }
          }
        }

        .right_line {
          border-left: 1px solid #e5e5e5;
        }
      }
    }
  }

  >>>.userCenter .userCenterInfo {
    background-color: #ffffff !important;
  }

  >>>.el-pagination {
    margin-top: 40px;
    text-align: right;

    .el-pager {
      li:not(.disabled):hover {
        color: #ff7800;
      }

      li:not(.disabled).active {
        background-color: #ff7800;
      }

      li:not(.disabled).active:hover {
        color: #f4f4f5;
      }
    }
  }

  .weChatBox {
    // display: flex;
    text-align: center;

    img {
      width: 100%;
    }

    .qCode {
      width: 100%;
      text-align: center;

      img {
        width: 80%;
      }
    }

    .weChatInfo {
      width: 50%;
    }
  }

  .weChat {
    >>>.el-dialog__body {
      background: #ffffff;
    }
  }

  >>>.el-dialog {

    // width: 33% !important;
    .el-dialog__body {
      background: #f8f8f8;
    }

    .el-dialog__header {
      text-align: center;
    }

    .el-dialog__footer {
      text-align: center;

      .dialog-footer {
        text-align: center;

        button {
          height: 45px;
          width: 160px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/orderList_serv.vue